import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HasRoleDirective } from './has-role.directive';
import { DisableIfNoRoleDirective } from './disable-if-no-role.directive';



@NgModule({
  declarations: [
    HasRoleDirective,
    DisableIfNoRoleDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HasRoleDirective,
    DisableIfNoRoleDirective
  ]
})
export class DirectivesModule { }
